import { render, staticRenderFns } from "./ActSelection.vue?vue&type=template&id=2088bc26&"
import script from "./ActSelection.vue?vue&type=script&lang=js&"
export * from "./ActSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports